enum Reasons {
  CONTROL_VIEWER = 'CONTROL_VIEWER',
  SUBSCRIBE_UPDATES = 'SUBSCRIBE_UPDATES',
}
export default Reasons;
